import React, { useEffect, useState } from 'react';
import { ChevronDown, Truck, Heart, FileText, Shield, Syringe, AlertCircle, Package, Ban, Activity, Stethoscope, Pill, Home, Toilet, HeartPulse, Frown, Eye, Meh, BicepsFlexed, Venus, Bug, Droplet, HandHelping } from 'lucide-react';

import './services.css'

const Services = () => {

    const [scrollY, setScrollY] = useState(0);
    const [openIndex, setOpenIndex] = useState(null);

    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

    }, []);

    const heroOpacity = Math.max(0, 1 - scrollY / 500);
    const heroScale = Math.max(0.9, 1 - scrollY / 2000);



    const services = [
        {
            title: "Free City Wide Delivery",
            icon: Truck,
            color: "#4A90E2",
            description: "We deliver your medications directly to your doorstep at no extra cost. Our reliable delivery service covers the entire city, ensuring you never miss a dose."
        },
        {
            title: "Medical Supplies",
            icon: Heart,
            color: "#E94B3C",
            description: "Complete range of medical supplies including ostomy supplies, adult diapers, wound care products, and mobility aids. We stock trusted brands and can special order items."
        },
        {
            title: "Direct Billing to Insurance & ODSP",
            icon: FileText,
            color: "#50C878",
            description: "We handle all the paperwork for you. Direct billing to all major insurance providers and ODSP means less hassle and faster processing of your claims."
        },
        {
            title: "Comprehensive Medication Reviews",
            icon: Shield,
            color: "#9B59B6",
            description: "Our pharmacists conduct thorough reviews of all your medications to identify potential interactions, optimize therapy, and ensure you're getting the most from your treatment."
        },
        {
            title: "Flu and COVID Vaccinations",
            icon: Syringe,
            color: "#F39C12",
            description: "Walk-in or by appointment. Our certified pharmacists provide safe and convenient vaccinations to protect you and your family throughout the year."
        },
        {
            title: "Naloxone Kits",
            icon: AlertCircle,
            color: "#E74C3C",
            description: "Free naloxone kits and training available. We're committed to community safety and provide education on recognizing and responding to opioid overdoses."
        },
        {
            title: "Blister Packaging",
            icon: Package,
            color: "#3498DB",
            description: "Organize your medications with our blister pack service. Each dose is individually packaged by date and time, making it easier to manage complex medication schedules."
        },
        {
            title: "Smoking Cessation",
            icon: Ban,
            color: "#16A085",
            description: "Personalized quit smoking programs with ongoing support. We offer counseling, nicotine replacement therapy options, and regular follow-ups to help you succeed."
        },
        {
            title: "Diabetes Therapy Optimization",
            icon: Activity,
            color: "#E67E22",
            description: "Expert guidance on blood sugar management, medication adjustments, and lifestyle modifications. We work with your doctor to optimize your diabetes care."
        },
        {
            title: "Minor Ailment Prescribing",
            icon: Stethoscope,
            color: "#1ABC9C",
            description: "Our pharmacists can assess and prescribe for minor ailments like the issues listed below. Get treated quickly without a doctor's appointment.",
            subItems: [
                {
                    title: "Digestive Conditions", items: [
                        { name: "Hemorroids", icon: Toilet },
                        { name: "Heartburn", icon: HeartPulse }
                    ]
                },
                {
                    title: "Eyes, Ears, Nose, or Mouth", items: [
                        { name: "Allergies", icon: Frown },
                        { name: "Oral Thrust", icon: Stethoscope },
                        { name: "Cold Sores", icon: Meh },
                        { name: "Pink Eyes or Eye Allergies", icon: Eye }
                    ]
                },
                {
                    title: "Skin Conditions", items: [
                        { name: "Skin Infections (Impetigo)", icon: Droplet },
                        { name: "Skin Irritations (Dermatitis)", icon: Stethoscope },
                        { name: "Insect Bites and Hives - Lyme Disease Prevention", icon: Bug }
                    ]
                },
                {
                    title: "Urinary and Reproductive Conditions", items: [
                        { name: "Menstrual (Period) Cramps", icon: Venus },
                        { name: "Urinary Tract Infection", icon: Toilet },
                    ]
                },
                {
                    title: "Other", items: [
                        { name: "Muscle Strains or Sprains", icon: BicepsFlexed },
                    ]
                }
            ]
        },
        {
            title: "Medicinal Compounding",
            icon: Pill,
            color: "#9B59B6",
            description: "Custom-formulated medications tailored to your specific needs. We can create unique dosages, flavors, and formulations not commercially available."
        },
        {
            title: "Free Pharmacist Home Visits",
            icon: Home,
            color: "#E91E63",
            description: "Can't make it to the pharmacy? Our pharmacists will come to you for medication reviews, education, and consultation in the comfort of your home."
        }
    ];

    const toggleService = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };


    return (
        <div className="services-container">

            <section
                className="hero-section-services"
                style={{
                    opacity: heroOpacity,
                    transform: `scale(${heroScale})`
                }}
            >
                <div className="hero-overlay-services"></div>
                <div className="hero-gradient-services"></div>

                {/* Animated background elements */}
                <div className="hero-bg-animation">
                    <div className="hero-blob hero-blob-1"></div>
                    <div className="hero-blob hero-blob-2"></div>
                </div>

                <div className="hero-content-services">
                    <div className="hero-icon-wrapper-services">
                        <HandHelping className="hero-icon" strokeWidth={1.5} />
                    </div>
                    <h1 className="hero-title-services">
                        Our services,<br />
                        <span className="hero-subtitle-services">are here to help you</span>
                    </h1>
                    {/* <p className="hero-description">
                                        Serving our community with compassion and excellence since 1998
                                    </p> */}
                </div>

                {/* <div className="scroll-indicator">
                                    <div className="scroll-indicator-border">
                                        <div className="scroll-indicator-dot"></div>
                                    </div>
                                </div> */}
            </section>

            {/* <div className='services-container'> */}
            {/* <div className='services-titleDiv'>
                <h1 className='subtitle'>Our Services</h1>
                <hr></hr>
            </div> */}

            <div className="services-content-wrapper">

                <div className="services-list-container">
                    {services.map((service, index) => {
                        const IconComponent = service.icon;
                        const isOpen = openIndex === index;

                        return (
                            <div
                                key={index}
                                className="service-card"
                            >
                                <button
                                    onClick={() => toggleService(index)}
                                    className="service-card-button"
                                >
                                    <div className="service-card-header">
                                        <div
                                            className="service-icon-circle"
                                            style={{
                                                backgroundColor: '#f9fafb',
                                                border: `2px solid ${service.color}20`
                                            }}
                                        >
                                            <IconComponent
                                                size={28}
                                                style={{ color: service.color }}
                                                strokeWidth={2}
                                            />
                                        </div>
                                        <h3 className="service-title">
                                            {service.title}
                                        </h3>
                                    </div>
                                    <ChevronDown
                                        className={`service-chevron ${isOpen ? 'service-chevron-open' : ''}`}
                                        size={24}
                                    />
                                </button>

                                <div className={`service-description-container ${isOpen ? 'service-description-open' : ''}`}>
                                    <div className="service-description-inner">
                                        <div
                                            className="service-description-border"
                                            style={{ borderColor: service.color }}
                                        >
                                            <p className="service-description-text">
                                                {service.description}
                                            </p>
                                            {service.subItems && (
                                                <div className="service-sub-items">
                                                    {service.subItems.map((group, groupIdx) => (
                                                        <div key={groupIdx} className="service-sub-group">
                                                            <span className="service-sub-title">{group.title}</span>
                                                            {group.items.map((item, itemIdx) => {
                                                                const SubIcon = item.icon;
                                                                return (
                                                                    <div key={itemIdx} className="service-sub-content">
                                                                        <div className="service-sub-icon">
                                                                            <SubIcon size={20} strokeWidth={2} />
                                                                        </div>
                                                                        <span className="service-sub-name">{item.name}</span>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    ))}

                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

            </div>

            {/* </div> */}
        </div>
    )
};

export default Services;